// Copyright (c) 2016 Deere & Company

import './non-editable-labor-panel.scss';
import React, {PropTypes} from 'react';
import ClaimLabor from '@deere/cps-it.warranty-model-factory/lib/claim-item-labor';
import LabeledCurrency from '../../../../shared/components/labeled-currency';
import LabeledString from '../../../../shared/components/labeled-string';
import {buildNumber} from '../../../../shared/services/build-number';
import {translate} from '../../../../shared/services/translation-service';

const NonEditableLaborPanel = props =>
    <section className='non-editable-labor-panel'>
        <h3>{`${buildNumber(props.labor.laborHours)} - ${translate('HOURS')} ${props.labor.laborType.value}`}</h3>
        {props.labor.spgJobCode &&
            <div className='labor-comment'>
                {props.labor.spgJobCode}
            </div>
        }
        <div className='labor-panel-row'>
            <LabeledString
                className='lost-two-column'
                data={props.labor.location.value}
                label='LOCATION'
            />
            <LabeledCurrency
                className='additive'
                data={props.labor.laborAdditive}
                label='ADDITIVE'
            />
            <LabeledCurrency
                className='value'
                data={props.labor.laborValue}
                label='VALUE'
            />
        </div>
        <div className='labor-panel-row'>
            <LabeledString
                className='lost-two-column'
                data={props.labor.techId}
                label='TECH_ID'
            />
            <LabeledCurrency
                className='tax'
                data={props.labor.taxAmount}
                label='TAX'
            />
            <LabeledCurrency
                className='reimbursed'
                data={props.labor.reimbursementAmount}
                label='REIMBURSED'
            />
        </div>
    </section>;

NonEditableLaborPanel.displayName = 'NonEditableLaborPanel';
NonEditableLaborPanel.propTypes = {
    highlightClass: PropTypes.string,
    labor: PropTypes.instanceOf(ClaimLabor).isRequired
};

export default NonEditableLaborPanel;



// WEBPACK FOOTER //
// ./src/claim/shared/components/labors-panel/non-editable-labor-panel.js